import * as mttTypes from '@/store/mutationTypes'
// import {devMntAPI} from '@/api/restfulAPI'

const state = {
  devInfos: []
}

const getters = {
  devInfos: state => {
    return state.devInfos
  }
}

const mutations = {
  [mttTypes.GET_DEV_INFOS] (state, devInfos) {
    state.devInfos = devInfos
  }
}

const actions = {
  getDevInfos ({commit, state}, param) {
    // let devInfos = []
    // devMntAPI.listDevInfos(param, null, null).then(data => {
    //   devInfos = data.data
    //   commit(mttTypes.GET_DEV_INFOS, devInfos)
    // }).catch(error => {
    //   console.log(error)
    // })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/devMnt.js